export const FETCH_RECRUITMENT_REQUISITION_REQUEST = 'FETCH_RECRUITMENT_REQUISITION_REQUEST';
export const FETCH_RECRUITMENT_REQUISITION_SUCCESS = 'FETCH_RECRUITMENT_REQUISITION_SUCCESS';
export const FETCH_RECRUITMENT_REQUISITION_FAILURE = 'FETCH_RECRUITMENT_REQUISITION_FAILURE';

export const SAVE_RECRUITMENT_REQUISITION_REQUEST = 'SAVE_RECRUITMENT_REQUISITION_REQUEST';
export const SAVE_RECRUITMENT_REQUISITION_SUCCESS = 'SAVE_RECRUITMENT_REQUISITION_SUCCESS';
export const SAVE_RECRUITMENT_REQUISITION_FAILURE = 'SAVE_RECRUITMENT_REQUISITION_FAILURE';

export const CHANGE_REQUISITION_STATUS_REQUEST = "CHANGE_REQUISITION_STATUS_REQUEST";
export const CHANGE_REQUISITION_STATUS_SUCCESS = "CHANGE_REQUISITION_STATUS_SUCCESS";
export const CHANGE_REQUISITION_STATUS_FAILURE = "CHANGE_REQUISITION_STATUS_FAILURE";